import { useTranslation } from 'react-i18next'
import { Check, Bell } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { ScrollArea } from '@/components/ui/scroll-area'
import { Separator } from '@/components/ui/separator'
import { useNotifications } from '../hooks/useNotifications'
import { useMarkAsRead } from '../hooks/useMarkAsRead'
import { useMarkAllAsRead } from '../hooks/useMarkAllAsRead'
import { NotificationItem } from './NotificationItem'

export function NotificationsList() {
  const { t } = useTranslation()
  const { data: notifications = [], isLoading } = useNotifications()
  const markAsRead = useMarkAsRead()
  const markAllAsRead = useMarkAllAsRead()

  const unreadExists = notifications.some(n => !n.is_read)

  if (isLoading) {
    return (
      <div className="p-4 text-center text-sm text-muted-foreground">
        {t('common.loading')}
      </div>
    )
  }

  return (
    <div>
      <div className="flex items-center justify-between px-4 py-3">
        <h4 className="text-sm font-semibold">{t('notifications.title')}</h4>
        {unreadExists && (
          <Button
            variant="ghost"
            size="sm"
            className="h-auto p-0 text-xs text-muted-foreground hover:text-foreground"
            onClick={() => markAllAsRead.mutate()}
            disabled={markAllAsRead.isPending}
          >
            <Check className="mr-1 h-3 w-3" />
            {t('notifications.markAllRead')}
          </Button>
        )}
      </div>
      <Separator />
      {notifications.length === 0 ? (
        <div className="flex flex-col items-center justify-center py-8 text-muted-foreground">
          <Bell className="h-8 w-8 mb-2 opacity-50" />
          <p className="text-sm">{t('notifications.empty')}</p>
        </div>
      ) : (
        <ScrollArea className="h-[300px]">
          <div className="divide-y">
            {notifications.map((notification) => (
              <NotificationItem
                key={notification.id}
                notification={notification}
                onMarkAsRead={() => markAsRead.mutate(notification.id)}
              />
            ))}
          </div>
        </ScrollArea>
      )}
    </div>
  )
}
